import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button, B2Card } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import * as _ from "lodash";
import { createRef, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { getGatewayGroup } from "../../../../../../core/api/services/asset/gateway-group.service";
import { getDayLightHarvestingProfile } from "../../../../../../core/api/services/asset/light-profile/daylight-harvesting.service";
// import { getToken } from "../../../../../../core/auth/auth.service";
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import HasPermission from "../../../../../../core/guards/has-permission";
import {
  convertTo24Hour,
  removeSecondsFromTime,
} from "../../../../../../shared/helpers/convert-time-format";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import capitalizeFirst from "../../../../../../shared/helpers/upper-case";
import TitleComponent from "../../../../../../shared/title/title.component";
import {
  enableOrDisableDayLightHarvestingProfile,
  getDaysOfWeek,
  postDayLightHarvestingProfile,
  sendGetCommandToDms,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";
import AssetActionFormComponent from "../common/asset-action-form.component";
import { getUserInfo } from "src/core/auth/auth.service";
import { displayToast } from "src/shared/helpers/toaster.helper";

const DaylightHarvestingComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const formRef = createRef();
  const user = getUserInfo();

  const [PageNumber, setPageNum] = useState<number>(1);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [searchValue, setSearchValue] = useState("");
  const pageSize = 10;
  const [isEnable, setIsEnable] = useState<boolean>(false);
  const [submittedFormData, setSubmittedFormData] = useState<any>({});
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const [initialValues, setInitialValues] = useState<any>({
    profileName: "",
    startTime: "",
    endTime: "",
    repeatAction: 30,
    daysOfWeek: "",
    zoneId: "",
    minLuminanceLevel: "",
    maxLuminanceLevel: "",
    daylightThreshold: "",
    isEnabled: "",
  });

  // const [isCallRetry, setIsCallRetry] = useState(false);
  // const [retryCount, setRetryCount] = useState<number>(0);
  // const [socketStatus, setSocketStatus] = useState("initial");
  // const [socket, setSocket] = useState<any>(null);
  // const token = getToken();

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  // const connectSocket = () => {
  //   const daylightHarvestingProfileClient = new W3CWebSocket(
  //     `${process.env.REACT_APP_WS_BASE_URL}/slpapp/push?name=asset-daylightharvestprofile`
  //   );

  //   daylightHarvestingProfileClient.onopen = () => {
  //     console.log("WebSocket Daylight Harvesting Profile Client Connected");

  //     setSocketStatus("open");
  //     daylightHarvestingProfileClient.send(
  //       JSON.stringify({ token: new Date().getUTCMilliseconds() })
  //     );
  //     setRetryCount(0);
  //   };

  //   daylightHarvestingProfileClient.onmessage = (message) => {
  //     const data = JSON.parse(`${message.data}`);
  //     const user = getUserInfo();
  //     if (
  //       user.email.toLowerCase() === data.NotificationIdentifier.toLowerCase()
  //     ) {
  //       toast.success("Acknowledgement Received", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnFocusLoss: true,
  //         draggable: true,
  //         pauseOnHover: true,
  //       });
  //     }

  //     refetchDaylightHarvestingProfile();
  //   };

  //   daylightHarvestingProfileClient.onclose = (event) => {
  //     console.log("WebSocket Daylight Harvesting Profile Closed", event);

  //     setSocketStatus("closed");
  //     setIsCallRetry((prev: boolean) => !prev);
  //   };

  //   setSocket(daylightHarvestingProfileClient);
  // };

  // useEffect(() => {
  //   setRetryCount((current: number) => current + 1);

  //   if (socketStatus == "initial") {
  //     connectSocket();
  //   } else if (socketStatus == "closed") {
  //     if (retryCount < WEBSOCKET_MAX_RETRY_COUNT) {
  //       setTimeout(() => {
  //         console.log(
  //           `Daylight Harvesting Profile Retry Attempts ${retryCount}/${WEBSOCKET_MAX_RETRY_COUNT}}`
  //         );

  //         connectSocket();
  //       }, 5000);
  //     } else {
  //       console.log(
  //         `Maximum retry attempts reached for Daylight Harvesting Profile WebSocket`
  //       );
  //     }
  //   }

  //   return () => {
  //     if (socket && socket.readyState === socket.OPEN) {
  //       socket.close();
  //       console.log("Daylight Harvesting Profile Client socket closed");
  //     }
  //   };
  // }, [socketStatus, isCallRetry]);

  const {
    data: daylightHarvestingProfiles,
    refetch: refetchDaylightHarvestingProfile,
    isFetching,
  } = useQuery({
    queryKey: [
      "getDayLightHarvestingProfile",
      pageSize,
      PageNumber,
      SortBy,
      SortDirection,
      id,
      searchValue,
    ],
    queryFn: () =>
      getDayLightHarvestingProfile(
        pageSize,
        PageNumber,
        SortBy,
        SortDirection,
        id,
        searchValue
      ),
    // enabled: onRefetchEnabled
  });

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.DayLightHarvest) {
      showToaster(socketRealTimeUpdateData);
      refetchDaylightHarvestingProfile();
      // setOnRefetchEnabled(true);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  const { data: gatewayGroups } = useQuery({
    queryKey: ["getGatewayGroup", id],
    queryFn: () => getGatewayGroup(id!),
  });

  useEffect(() => {
    const groups = gatewayGroups?.data?.map((group: any) => ({
      value: group?.zoneId,
      label: group?.groupName + ` (Zone - ${group?.zoneId})`,
    }));

    setGroupOptions(groups);
  }, [gatewayGroups]);

  useEffect(() => {
    setInitialValues({
      profileName: daylightHarvestingProfiles?.profileName,
      startTime: removeSecondsFromTime(daylightHarvestingProfiles?.startTime),
      endTime: removeSecondsFromTime(daylightHarvestingProfiles?.endTime),
      zoneId: daylightHarvestingProfiles?.zoneId,
      daysOfWeek: daylightHarvestingProfiles?.dayOfWeek,
      minLuminanceLevel: daylightHarvestingProfiles?.minLuminance,
      maxLuminanceLevel: daylightHarvestingProfiles?.maxLuminance,
      daylightThreshold: daylightHarvestingProfiles?.dayLightThreshold,
      repeatAction: daylightHarvestingProfiles?.repeatAction,
      isEnabled: daylightHarvestingProfiles?.isEnabled,
    });
  }, [daylightHarvestingProfiles]);

  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });

    dispatch(getDaysOfWeek());
  }, [dispatch]);

  const daysOfWeek = useSelector((state: any) => {
    return state.asset.daysOfWeek;
  });

  const [daysOfWeekOptions, setDaysOfWeekOptions] = useState<any>([]);

  useEffect(() => {
    const days = daysOfWeek?.map((day: any) => ({
      value: day?.id,
      label: day?.name,
    }));

    setDaysOfWeekOptions(days);
  }, [daysOfWeek]);

  const formConfig = {
    controls: [
      {
        label: "Daylight Profile",
        isGrid: true,
        isShadow: false,
        gridClass: "profile-grid",
        controlGroup: [
          {
            name: "startTime",
            label: "Start Time",
            placeholder: "",
            type: "time",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "endTime",
            label: "End Time",
            placeholder: "",
            type: "time",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },

          {
            name: "minLuminanceLevel",
            label: "Min Luminance Level (%)",
            placeholder: "e.g: 10",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "maxLuminanceLevel",
            label: "Max Luminance Level (%)",
            placeholder: "e.g: 80",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "repeatAction",
            label: "Repeat Action",
            placeholder: "Repeat Action",
            type: "number",
            readOnly: isDetails,
            disabled: isDetails,
          },

          {
            name: "daylightThreshold",
            label: "Daylight Threshold (Lux)",
            placeholder: "e.g: 1000",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },

          {
            name: "daysOfWeek",
            label: "Days Of Week",
            placeholder: "Select Days Of Week",
            type: "select",
            options: daysOfWeekOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "zoneId",
            label: "Group",
            placeholder: "Select Group",
            type: "select",
            options: groupOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "isEnabled",
            label: "Profile Control",
            placeholder: "",
            type: "switch",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
        ],
      },
    ],
  };

  const handleCloseModal = () => {
    setIsEdit(false);
    setIsDetails(false);
    setIsDelete(false);
  };

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();
      const {
        startTime,
        endTime,
        zoneId,
        daysOfWeek,
        minLuminanceLevel,
        maxLuminanceLevel,
        daylightThreshold,
        repeatAction,
      } = form.values;

      if (
        !startTime ||
        !endTime ||
        !zoneId ||
        !daysOfWeek ||
        !minLuminanceLevel ||
        !maxLuminanceLevel ||
        !daylightThreshold ||
        repeatAction < 0
      ) {
        return;
      }

      // setIsOtpModalOpen(true);
      setIsEnable(true);

      const data = {
        ...form.values,
        startTime: convertTo24Hour(form.values.startTime),
        endTime: convertTo24Hour(form.values.endTime),
        daysOfWeek: Number.parseInt(form.values.daysOfWeek),
        assetCode: id,
      };
      setInitialValues(data);
      setSubmittedFormData(data);

      if (mfaInfo?.isDMSMfaEnabled) {
        setIsOtpModalOpen(true);
      } else {
        onSubmitMfaOtp(data);
      }
    }

    handleCloseModal();
  };

  const validation = yup.object().shape({
    startTime: yup.string().required("Start Time is required"),
    endTime: yup.string().required("End Time is required"),
    repeatAction: yup.number().min(0, "Should be a positive number"),
    daysOfWeek: yup.string().required("Days Of Weeks is required"),
    zoneId: yup.string().required("Zone is required"),
    minLuminanceLevel: yup.string().required("Min Luminance Level is required"),
    maxLuminanceLevel: yup.string().required("Max Luminance Level is required"),
    daylightThreshold: yup.string().required("Day-light Threshold is required"),
  });

  const onSubmitMfaOtp = (data?: any) => {
    dispatch(
      postDayLightHarvestingProfile({ body: data ?? submittedFormData })
    ).then((res: any) => {
      console.log(
        "postDayLightHarvestingProfile: ",
        postDayLightHarvestingProfile
      );

      dispatch(
        enableOrDisableDayLightHarvestingProfile({
          id: res?.payload?.data?.id,
        })
      );

      refetchDaylightHarvestingProfile();
    });

    handleCloseOtpModal();
    dispatch(setOtpIsValidation(false));
  };

  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const handleCloseOtpModal = () => {
    setIsOtpModalOpen(false);
  };

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const handleRefresh = () => {
    setIsRefreshing(true);

    dispatch(
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.DayLightHarvest),
      })
    )
      .then(() => {
        refetchDaylightHarvestingProfile()
          .then(() => {
            setIsRefreshing(false);
          })
          .catch(() => {
            setIsRefreshing(false);
          });
      })
      .catch(() => {
        setIsRefreshing(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Daylight Harvesting | Asset</title>
      </Helmet>
      <div>
        <div>
          <div className="my-5">
            <TitleComponent title="Configure Daylight Harvesting Profile" />
          </div>
          <div className="my-3">
            <B2Card className="card-bg">
              <B2Card.Header className="fs-5 fw-bold header-bg">
                <div className="d-flex form-header dashboard-generic-actions align-items-center">
                  <p className="m-0 flex-grow-1">Profile Information</p>
                  <button
                    type="button"
                    className="ms-2 cursor-pointer fs-6 fw-bold"
                    onClick={handleRefresh}
                    style={{
                      padding: "0",
                      background: "none",
                      border: "none",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faRotateRight}
                      className="fs-7 me-2"
                    />
                    Refresh
                  </button>
                </div>
              </B2Card.Header>

              <B2Card.Body>
                {isRefreshing || isFetching ? (
                  <div
                    className="d-flex justify-content-center"
                    style={{ minHeight: "400px" }}
                  >
                    <Spinner
                      animation="border"
                      variant="primary"
                      className="mt-5"
                    />
                  </div>
                ) : (
                  <div>
                    <AssetActionFormComponent
                      formRef={formRef}
                      validation={validation}
                      initialValues={initialValues}
                      formConfig={formConfig}
                      moduleName={"DayLight Harvesting"}
                      actionName={"Edit-DayLight Harvesting"}
                    />

                    <div>
                      <HasPermission
                        moduleName="DayLight Harvesting"
                        actionName="Edit-DayLight Harvesting"
                        isRoute={false}
                      >
                        <B2Button onClick={() => onSubmit()}>Save</B2Button>
                      </HasPermission>
                    </div>
                  </div>
                )}
              </B2Card.Body>
            </B2Card>
          </div>
        </div>

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default DaylightHarvestingComponent;
